import React, { useEffect, useState, useMemo, useCallback } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Row,
  CardTitle,
} from "reactstrap";
import * as moment from "moment";
import BreadCrumb from "../../Components/Common/BreadCrumb";

//redux
import { useSelector, useDispatch } from "react-redux";

import Flatpickr from "react-flatpickr";
import Select from "react-select";

//Import actions
import {
  getImports as onGetImports,
  getSuppliers as onGetSuppliers,
  updateRow as onUpdateRow,
  updateStatus as onUpdateStatus,
} from "../../slices/thunks";

import Loader from "../../Components/Common/Loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { createSelector } from "reselect";
import { uploadStockCheckFile } from "../../apiCalls/caller";

//AG GRID
import NumericEditor from "../../Components/Common/numericEditor";
import AsinRenderer from "../../Components/Common/AsinRendered.jsx";

import { AgGridReact } from "ag-grid-react";
import { ModuleRegistry, CsvExportModule } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager, ExcelExportModule } from "ag-grid-enterprise";
import { productsStatus } from "../../Components/constants/layout";
import RejectModal from "../../Components/Common/RejectModal";
import StatusUpdateResultModal from "../../Components/Common/StatusUpdateResultModal";
import StockCheckUploadModal from "../../Components/Common/StockCheckUploadModal";

ModuleRegistry.registerModules([CsvExportModule, ExcelExportModule, AllEnterpriseModule]);
LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-076901}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Cartzy}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{BCAT}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{BCAT}_need_to_be_licensed___{BCAT}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{11_February_2026}____[v3]_[01]_MTc3MDc2ODAwMDAwMA==4a557ef1e71d7e706797c31212266eae"
);

const StockCheck = () => {
  const [gridApi, setGridApi] = useState(null);
  const [modal, setModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [resultModal, setResultModal] = useState(false);
  const [updateResult, setUpdateResult] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedAnalysisStatus, setSelectedAnalysisStatus] = useState([
    { label: "Working", value: 4 },
  ]);
  const [selectedSalesChannels, setSelectedSalesChannels] = useState([]);
  const [suppliersList, setSuppliersList] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [dateFrom, setDateFrom] = useState(moment());
  const [dateTo, setDateTo] = useState(moment());

  const analysisStatus = [
    {
      options: [
        { label: "Working", value: 4 },
        { label: "Rejected", value: 6 },
        { label: "Ready For FA", value: 3 },
      ],
    },
  ];

  const salesChannels = [
    { label: "FBA", value: "FBA" },
    { label: "FBM", value: "FBM" },
    { label: "eBay", value: "ebay" },
    { label: "Walmart", value: "walmart" },
  { label: "Other", value: "other" },
  { label: "Online Store", value: "online" },
  { label: "LIQUIDATIONS", value: "liquidations" },
  ];
  const dispatch = useDispatch();

  const selectFilesData = createSelector(
    (state) => state.Analysis,
    (imports) => imports,
    (updatedStatus) => updatedStatus,
    (updatedRow) => updatedRow,
    (error) => error
  );

  const selectSuppliersData = createSelector(
    (state) => state.Suppliers.suppliers,
    (suppliers) => suppliers
  );

  const suppliers = useSelector(selectSuppliersData);
  const { imports, updatedStatus, updatingStatus, error } = useSelector(selectFilesData);

  const [rowData, setRowData] = useState([]);
  const rowSelection = {
    mode: "multiRow",
    headerCheckbox: true,
  };

  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      suppressHeaderMenuButton: true,
    };
  }, []);

  const saveNewValue = (params) => {
    return false;
  };

  const getSelectedSalesChannels = () => {
    let salesChannel = 0;

    selectedSalesChannels.forEach((item) => {
      switch (item.value) {
        case "FBA":
          salesChannel += 1;
          break;
        case "FBM":
          salesChannel += 2;
          break;
        case "eBay":
          salesChannel += 4;
          break;
        case "walmart":
          salesChannel += 8;
          break;
        case "other":
          salesChannel += 16;
          break;
        case "online":
          salesChannel += 32;
          break;
        case "liquidations":
          salesChannel += 64;
          break;
        default:
          break;
      }
    });
    return salesChannel;
  };

  const getImports = () => {
    const status = selectedAnalysisStatus.map((item) => item.value);
    if (status.indexOf(6) > -1) {
      status.push(7);
      status.push(8);
    }
    dispatch(
      onGetImports({
        status: status.length > 0 ? status : null,
        sup_id: supplier.length > 0 ? supplier.map((item) => item.value) : null,
        date_from: moment(dateFrom).format("YYYY-MM-DD"),
        date_to: moment(dateTo).format("YYYY-MM-DD"),
        current_status: productsStatus.STATUS_READYFORSTOCK,
      })
    );
  };
  const autoSizeStrategy = useMemo(() => {
    return {
      type: "fitGridWidth",
      defaultMinWidth: 100,
    };
  }, []);
  // Column Definitions: Defines the columns to be displayed.
  const [colDefs, setColDefs] = useState([
    {
      headerName: "ASIN",
      field: "imp_ASIN",
      pinned: "left",
      filter: true,
      suppressMovable: true,
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      cellRenderer: AsinRenderer,
    },
    {
      headerName: "UPC",
      field: "imp_UPC",
      pinned: "left",
      suppressMovable: true,
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Product ID",
      field: "imp_productID",
      pinned: "left",
      suppressMovable: true,
      headerStyle: { "background-color": "#90EE90" },
    },
    {
      headerName: "Vendor",
      field: "imp_ven_name",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Brand",
      field: "imp_brand",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Title",
      field: "imp_title",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },

    {
      headerName: "Pack Qty. (check title)",
      field: "imp_packQuantity",
      selectable: true,
      editable: true,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Vendor Cost",
      field: "imp_vendorCost",
      editable: true,
      valueSetter: saveNewValue,
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "MAP",
      field: "imp_MAP",
      editable: true,
      cellEditor: "agNumberCellEditor",
      valueSetter: saveNewValue,
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#F9CB9C" },
      cellClass: "age-border",
    },
    {
      headerName: "Lead Time",
      field: "imp_leadTime",
      editable: true,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#F9CB9C" },
      cellClass: "age-border",
    },
    {
      headerName: "Case Qty.",
      field: "imp_caseQuantity",
      editable: true,
      cellEditor: NumericEditor,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#F9CB9C" },
      cellClass: "age-border",
    },
    {
      headerName: "Confirmed Stock",
      field: "imp_confirmedStock",
      editable: true,
      cellEditor: NumericEditor,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#F9CB9C" },
      cellClass: "age-border",
    },
    {
      headerName: "MOQ",
      field: "imp_MOQ",
      minWidth: 80,
      editable: true,
      cellEditor: NumericEditor,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#F9CB9C" },
      cellClass: "age-border",
    },
    {
      headerName: "MOV",
      field: "imp_MOV",
      minWidth: 100,
      editable: true,
      cellEditor: "agNumberCellEditor",
      valueSetter: saveNewValue,
      valueFormatter: (params) => currencyFormatter(params.value),
      headerStyle: { "background-color": "#F9CB9C" },
      cellClass: "age-border",
    },
    {
      headerName: "STOCK NOTES",
      field: "imp_stockNotes",
      editable: true,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#FFF" },
      cellClass: "age-border",
    },
    {
      headerName: "ANALISYS NOTES",
      field: "imp_notes",
      headerStyle: { "background-color": "#FFF" },
      cellClass: "age-border",
    },
    {
      headerName: "Rejection Reason",
      field: "imp_rejectionReason",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
  ]);
  const currencyFormatter = (currency) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(currency);
  };

  useEffect(() => {
    setRowData(imports);
  }, [imports]);

  useEffect(() => {
    if (suppliers) {
      setSuppliersList(
        suppliers.map((item) => ({ label: item.sup_name, value: item.sup_id }))
      );
    }
  }, [suppliers]);

  useEffect(() => {
    if (updatedStatus) {
      getImports();
    }
  }, [updatedStatus]);

  useEffect(() => {
    if (!suppliers || suppliers.length === 0) {
      const data = {
        page: 0,
        total_rows: 1000,
        sort_by: "sup_name",
      };
      dispatch(onGetSuppliers(data));
    }
    getImports();
  }, []);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
      setDate(defaultdate());
    }
  }, [modal]);

  const defaultdate = () => {
    let d = new Date(),
      months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
    let h = d.getHours() % 12 || 12;
    let ampm = d.getHours() < 12 ? "AM" : "PM";
    return (
      d.getDate() +
      " " +
      months[d.getMonth()] +
      ", " +
      d.getFullYear() +
      ", " +
      h +
      ":" +
      d.getMinutes() +
      " " +
      ampm
    ).toString();
  };

  const [date, setDate] = useState(defaultdate());

  const dateformate = (e) => {
    const dateString = e.toString().split(" ");

    let time = dateString[4];
    let H = +time.substr(0, 2);
    let h = H % 12 || 12;
    h = h <= 9 ? (h = "0" + h) : h;
    let ampm = H < 12 ? "AM" : "PM";
    time = h + time.substr(2, 3) + " " + ampm;

    const date = dateString[2] + " " + dateString[1] + ", " + dateString[3];
    const orderDate = (date + ", " + time).toString();
    setDate(orderDate);
  };

  const handleValidDate = (date) => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };

  function handleAnalysisStatus(status) {
    setSelectedAnalysisStatus(status);
  }

  const onCellEditingStopped = (event) => {
    const row = event.data;
    // console.log("event.column.colId", event.column.colId);
    let newRow;
    switch (event.column.colId) {
      case "imp_MAP":
        newRow = { ...row, imp_MAP: event.newValue };
        break;
      case "imp_stockNotes":
        newRow = { ...row, imp_stockNotes: event.newValue };
        break;
      case "imp_leadTime":
        newRow = { ...row, imp_leadTime: event.newValue };
        break;
      case "imp_caseQuantity":
        newRow = { ...row, imp_caseQuantity: event.newValue };
        break;
      case "imp_packQuantity":
        newRow = { ...row, imp_packQuantity: event.newValue };
        break;
      case "imp_confirmedStock":
        newRow = { ...row, imp_confirmedStock: event.newValue };
        break;
      case "imp_vendorCost":
        newRow = { ...row, imp_vendorCost: event.newValue };
        break;
      case "imp_MOQ":
        newRow = { ...row, imp_MOQ: event.newValue };
        break;
      case "imp_MOV":
        newRow = { ...row, imp_MOV: event.newValue };
        break;
      default:
        newRow = { ...row };
    }
    dispatch(onUpdateRow(JSON.stringify(newRow)));
    const newData = [...rowData];
    const index = rowData.findIndex((item) => item.imp_id === row.imp_id);
    newData[index] = newRow;
    setRowData(newData);
    return false;
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const onBtExport = () => {
    const analysisStatusLabels = selectedAnalysisStatus
      .map((status) => status.label)
      .join("_");

    gridApi.exportDataAsExcel({
      fileName:
        "StockCheck_" +
        moment(dateFrom).format("YYYYMMDD") +
        "_" +
        moment(dateTo).format("YYYYMMDD") +
        "_" +
        analysisStatusLabels +
        (supplier.length > 0
          ? "_" +
            suppliersList
              .filter((s) => supplier.some((sup) => sup.value === s.value))
              .map((s) => s.label)
              .join("_")
          : "") +
        ".xlsx",
    });
  };

  const onSelectionChanged = () => {
    const selectedData = gridApi.getSelectedRows();
    setSelectedRows(selectedData);
  };

  const handleStockCheckUpload = async (formData) => {
    const response = await uploadStockCheckFile(formData);

    if (!response?.success) {
      return {
        success: false,
        message: response?.message || "Failed to process the stock check file.",
        data: response?.data,
      };
    }

    return response;
  };

  const defaultUploadSupplier = supplier.length === 1 ? supplier[0] : null;

  const handleUpdateStatus = async (statusData) => {
    try {
      const resultAction = await dispatch(onUpdateStatus(statusData));
      if (resultAction.payload?.success) {
        const result = resultAction.payload.data;
        
        // Show appropriate toast based on status
        if (result.status === "Success") {
          toast.success(result.summaryMessage || "Status updated successfully", {
            position: "top-center",
            autoClose: 2000,
          });
        } else if (result.status === "Parcial") {
          toast.warning(result.summaryMessage || "Status updated with some errors", {
            position: "top-center",
            autoClose: 3000,
          });
        } else if (result.status === "Failed") {
          toast.error(result.summaryMessage || "Failed to update status", {
            position: "top-center",
            autoClose: 3000,
          });
        }
        
        // Show detailed modal only for partial success or failures
        if (result.status === "Parcial" || result.status === "Failed") {
          setUpdateResult(result);
          setResultModal(true);
        }
      }
    } catch (error) {
      console.error("Update status error:", error);
    }
  };

  const handleRejectProduct = (reason) => {
    handleUpdateStatus({
      imp_ids: selectedRows.map((item) => item.imp_id),
      imp_status: productsStatus.STATUS_REJECTED_STOCK,
      imp_rejectionReason: reason,
    });
    setModal(false);
  };

  document.title = "Stock Check | Buyers Club";
  return (
    <div className="page-content">
      <RejectModal
        show={modal}
        type="stock"
        onRejectClick={(reason) => handleRejectProduct(reason)}
        onCloseClick={() => setModal(false)}
      />
      <StockCheckUploadModal
        show={uploadModal}
        suppliers={suppliersList}
        initialSupplier={defaultUploadSupplier}
        onCloseClick={() => setUploadModal(false)}
        onSubmit={handleStockCheckUpload}
        onSuccess={() => getImports()}
      />
      <StatusUpdateResultModal
        show={resultModal}
        result={updateResult}
        onCloseClick={() => {
          setResultModal(false);
          setUpdateResult(null);
        }}
      />
      <Container fluid>
        <BreadCrumb title="Stock Check" pageTitle="Analysis" />
        <Row>
          <Col lg={12}>
            <Card id="refreshesList">
              <CardHeader className="border-0">
                <Row className="align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">Initial Analysis</h5>
                  </div>
                </Row>
              </CardHeader>

              <CardBody className="pt-0">
                <Card className=" p-2">
                  <CardTitle className="mb-2">
                    <h5 className="card-title mb-0">Filters</h5>
                  </CardTitle>
                  <Row className="mb-2">
                    <Col xs={12} sm={12} xl={3} className="d-flex gap-3 mb-2">
                      <div>
                        <label htmlFor="analysisDate" className="form-label">
                          Date From
                        </label>
                        <Flatpickr
                          className="form-control"
                          id="datepicker-publish-input"
                          placeholder="Select a date from"
                          onChange={(selectedDates, dateStr, instance) => {
                            setDateFrom(selectedDates[0]);
                          }}
                          options={{
                            defaultDate: moment(dateFrom).format("MM-DD-YYYY"),
                            mode: "single",
                            dateFormat: "m-d-Y",
                          }}
                        />
                      </div>

                      <div>
                        <label htmlFor="analysisDate" className="form-label">
                          Date To
                        </label>
                        <Flatpickr
                          className="form-control"
                          id="datepicker-publish-input"
                          label="To"
                          placeholder="Select a date to"
                          onChange={(selectedDates, dateStr, instance) => {
                            setDateTo(selectedDates[0]);
                          }}
                          options={{
                            defaultDate: moment(dateTo).format("MM-DD-YYYY"),
                            mode: "single",
                            dateFormat: "m-d-Y",
                          }}
                        />
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={3}>
                      <label htmlFor="analysisStatus" className="form-label">
                        Analysis Status
                      </label>
                      <Select
                        autoFocus
                        label="Select Analysis Status"
                        placeholder="Select Status"
                        value={selectedAnalysisStatus}
                        onChange={(e) => {
                          handleAnalysisStatus(e);
                        }}
                        options={analysisStatus}
                        isMulti
                      />
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={3}>
                      <label htmlFor="supplier" className="form-label">
                        Supplier
                      </label>
                      <Select
                        placeholder="Select Supplier"
                        value={supplier}
                        onChange={(e) => {
                          setSupplier(e);
                        }}
                        options={suppliersList}
                        isMulti
                      />
                    </Col>

                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div>
                        <button
                          type="button"
                          className="btn btn-primary  mt-2"
                          onClick={() => getImports()}
                        >
                          {" "}
                          <i className="ri-equalizer-fill me-1 align-bottom"></i>
                          Filter
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Card>
                <div className="d-flex m-2">
                  <div className="d-flex gap-1 align-items-center">
                    <h4 className="text-muted">Total</h4>
                    <h4 className="text-muted">:</h4>
                    <h4 className="text-muted">{imports.length}</h4>
                    <h4 className="text-muted">|</h4>
                    <h4 className="text-muted">Selected</h4>
                    <h4 className="text-muted">:</h4>
                    <h4 className="text-muted">
                      {selectedRows.length > 0 ? selectedRows.length : 0}
                    </h4>
                  </div>
                  <div
                    className="d-flex gap-1 justify-content-end"
                    style={{ width: "100%" }}
                  >
                    <button
                      disabled={
                        updatingStatus ||
                        selectedRows.length === 0 ||
                        selectedRows.filter(
                          (item) =>
                            item.imp_status ===
                            productsStatus.STATUS_READYFORSTOCK
                        ).length === 0
                      }
                      type="button"
                      className="btn btn-info"
                      onClick={() =>
                        selectedRows.length > 0
                          ? handleUpdateStatus({
                              imp_ids: selectedRows.map(
                                (item) => item.imp_id
                              ),
                              imp_status: productsStatus.STATUS_READYFORFINAL,
                            })
                          : toast.error("Please select a product")
                      }
                    >
                      {updatingStatus && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                      Ready for Final Analysis
                    </button>
                    <button
                      disabled={
                        updatingStatus ||
                        selectedRows.length === 0 ||
                        selectedRows.filter(
                          (item) =>
                            item.imp_status ===
                            productsStatus.STATUS_READYFORSTOCK
                        ).length === 0
                      }
                      type="button"
                      className="btn btn-danger"
                      onClick={() =>
                        selectedRows.length > 0
                          ? handleUpdateStatus({
                              imp_ids: selectedRows.map(
                                (item) => item.imp_id
                              ),
                              imp_status: productsStatus.STATUS_IMPORTED,
                            })
                          : toast.error("Please select a product")
                      }
                    >
                      {updatingStatus && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                      Back to Initial
                    </button>
                    <button
                      disabled={
                        updatingStatus ||
                        selectedRows.length === 0 ||
                        selectedRows.filter(
                          (item) =>
                            item.imp_status ===
                            productsStatus.STATUS_READYFORFINAL
                        ).length === 0
                      }
                      type="button"
                      className="btn btn-danger"
                      onClick={() =>
                        selectedRows.length > 0
                          ? handleUpdateStatus({
                              imp_ids: selectedRows.map(
                                (item) => item.imp_id
                              ),
                              imp_status: productsStatus.STATUS_READYFORSTOCK,
                            })
                          : toast.error("Please select a product")
                      }
                    >
                      {updatingStatus && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                      Back to Stock Check
                    </button>
                    <button
                      disabled={updatingStatus || selectedRows.length === 0}
                      type="button"
                      className="btn btn-warning"
                      onClick={() =>
                        selectedRows.length > 0
                          ? setModal(true)
                          : toast.error(
                              "Please choose at least one product to proceed"
                            )
                      }
                    >
                      <i className="ri-prohibited-line"></i>
                      Reject Product
                    </button>
                    <button
                      disabled={updatingStatus || selectedRows.length === 0}
                      type="button"
                      className="btn btn-success"
                      onClick={() =>
                        selectedRows.length > 0
                          ? handleUpdateStatus({
                              imp_ids: selectedRows.map(
                                (item) => item.imp_id
                              ),
                              imp_status: productsStatus.STATUS_READYFORSTOCK,
                            })
                          : toast.error("Please select a product")
                      }
                    >
                      {updatingStatus && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                      <i className="ri-check-line"></i>
                      Un-Reject Product
                    </button>
                    <button
                      disabled={suppliersList.length === 0}
                      type="button"
                      className="btn btn-primary"
                      onClick={() => setUploadModal(true)}
                    >
                      <i className="ri-upload-2-line"></i>
                      Upload Stock
                    </button>
                    <button
                      disabled={imports.length === 0}
                      type="button"
                      className="btn btn-secondary"
                      onClick={onBtExport}
                    >
                      <i className="ri-file-download-line"></i>
                      Export
                    </button>
                  </div>
                </div>
                <div style={{ height: "70vh", width: "100%" }}>
                  <AgGridReact
                    onGridReady={onGridReady}
                    rowData={rowData}
                    defaultColDef={defaultColDef}
                    columnDefs={colDefs}
                    rowSelection={rowSelection}
                    maintainColumnOrder={true}
                    onCellEditingStopped={onCellEditingStopped}
                    suppressScrollOnNewData={true}
                    onSelectionChanged={onSelectionChanged}
                    cellSelection={true}
                    selectionColumnDef={{
                      pinned: "left",
                    }}
                    autoSizeStrategy={autoSizeStrategy}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default StockCheck;
